import { render, staticRenderFns } from "./product_11_gbw.vue?vue&type=template&id=7e0036f8&scoped=true"
import script from "./product_11_gbw.vue?vue&type=script&lang=js"
export * from "./product_11_gbw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0036f8",
  null
  
)

export default component.exports